import dialogComponent from './dialog.vue'

let $vm

const dialogPlugin = {
	install (vue, pluginOptions = {}) {
		const Dialog = vue.extend(dialogComponent)

		if (!$vm) {
			$vm = new Dialog({
				el: document.createElement('div')
			})
			document.body.appendChild($vm.$el)
		}

		const dialog = {
			show (options) {
				if(options.content){
					Object.assign($vm, pluginOptions, {content: options.content})
				}
				if(options.title){
					Object.assign($vm, pluginOptions, {title: options.title})
				}
				if(options.okText){
					Object.assign($vm, pluginOptions, {okText: options.okText})
				}
				$vm.show = true
				$vm.$on('CloseEvent', () => {
					$vm.show = false
				})
				$vm.promise = new Promise((resolve, reject) => {
					$vm.$on('OkEvent', () => {
						$vm.show = false
						resolve()
					})
				})
				return $vm.promise
			}
		}
		vue.prototype.$dialog = dialog.show
	}
}

export default dialogPlugin



// WEBPACK FOOTER //
// ./src/components/common/dialog/index.js